import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { http, errorMessage } from "@/lib/api";

export const CustomCodeBox = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [state, setState] = useState({ loading: false, error: "" });
  const submit = async (e) => {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    if (c.length < 4) return setState({ error: "Please enter the code we gave you." });
    setState({ loading: true });
    try {
      const { data } = await http.get(`/custom-packages/${encodeURIComponent(c)}`);
      navigate(`/checkout?code=${encodeURIComponent(data.code)}`);
    } catch (err) {
      setState({ error: errorMessage(err) });
    }
  };
  return (
    <form onSubmit={submit} className="mx-auto mt-10 max-w-2xl scroll-mt-28 rounded-3xl border border-[#262626] bg-[#101010] p-6 sm:p-8" id="custom-code" data-testid="custom-code-box">
      <div className="flex items-center gap-3">
        <KeyRound className="h-5 w-5 text-[#D4A437]" />
        <h2 className="font-display text-xl sm:text-2xl font-bold">Have a custom package code?</h2>
      </div>
      <p className="mt-2 text-sm text-[#A1A1AA]">If we've put together a package just for you, enter your code to see it and subscribe.</p>
      <div className="mt-5 flex flex-col gap-3 sm:flex-row">
        <Input value={code} onChange={(e) => setCode(e.target.value)} placeholder="e.g. WLR-7KQ2M" maxLength={20} aria-label="Custom package code"
          className="lc-input uppercase tracking-widest" data-testid="custom-code-input" />
        <button type="submit" disabled={state.loading} className="lc-btn-primary shrink-0 !py-3" data-testid="custom-code-submit">
          {state.loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Use code"}
        </button>
      </div>
      {state.error && <p className="mt-3 text-sm text-[#ff8a3d]" role="alert" data-testid="custom-code-error">{state.error}</p>}
      <p className="mt-4 text-xs text-[#8a8a8a]">Want something different? <a href="/contact" className="text-[#FF6A00] hover:underline" data-testid="custom-code-contact">Get in touch</a> and we'll build a package around you. You can add our smokeless coal (20kg bags, £12 each) to any custom package.</p>
    </form>
  );
};
